import SectionHeading from "@/components/base/SectionHeading";
import { siteStats, testimonials } from "@/mocks/posts";

export default function CommunityStats() {
  const metrics = [
    { icon: "ri-file-list-3-line", value: siteStats.clues.toLocaleString("en-US"), label: "累计线索", note: "覆盖六大主题板块" },
    { icon: "ri-chat-smile-2-line", value: siteStats.discussions.toLocaleString("en-US"), label: "累计讨论", note: "平均每条 31 条评论" },
    { icon: "ri-group-line", value: `${(siteStats.users / 1000).toFixed(1)}k`, label: "参与用户", note: "遍布两百多个城市" },
  ];

  return (
    <section id="community" className="scroll-mt-24 bg-secondary-950 py-16 md:py-20">
      <div className="mx-auto w-full max-w-container px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-12">
          <div className="lg:col-span-5">
            <span className="inline-flex items-center gap-2 font-label text-xs md:text-sm tracking-[0.24em] text-accent-300 uppercase">
              <span className="h-px w-6 bg-accent-400" aria-hidden="true" />
              Community
            </span>
            <h2 className="mt-3 font-heading text-2xl md:text-4xl font-bold leading-tight text-background-50">
              评论区才是主战场
            </h2>
            <p className="mt-4 text-sm md:text-base leading-relaxed text-background-200/80">
              我们相信，一条线索的价值不只是它本身。当有人补充了时间、地点和另一种视角，讨论才真正开始变得完整。
            </p>

            <div className="mt-8 flex flex-col gap-4">
              {metrics.map((metric) => (
                <div key={metric.label} className="flex items-center gap-4 rounded-lg border border-background-50/10 bg-background-50/5 p-4">
                  <span className="flex h-12 w-12 items-center justify-center rounded-md bg-accent-500/15 text-accent-300">
                    <i className={`${metric.icon} text-2xl`} aria-hidden="true" />
                  </span>
                  <div>
                    <p className="font-heading text-2xl font-bold text-background-50">{metric.value}</p>
                    <p className="font-label text-xs text-background-200/70">
                      {metric.label} · {metric.note}
                    </p>
                  </div>
                </div>
              ))}
            </div>
          </div>

          <div className="lg:col-span-7">
            <div className="grid grid-cols-1 gap-4 sm:grid-cols-2">
              {testimonials.map((item, index) => (
                <figure
                  key={item.name}
                  className={`flex flex-col justify-between rounded-lg border border-background-50/10 bg-background-50/5 p-6 ${
                    index === 0 ? "sm:col-span-2" : ""
                  }`}
                >
                  <blockquote className="text-sm md:text-base leading-relaxed text-background-100">
                    “{item.quote}”
                  </blockquote>
                  <figcaption className="mt-5 flex items-center gap-3">
                    <span className="flex h-10 w-10 items-center justify-center rounded-full bg-accent-500 font-heading text-sm font-bold text-secondary-950">
                      {item.name.slice(0, 1)}
                    </span>
                    <span>
                      <span className="block font-label text-sm font-medium text-background-50">{item.name}</span>
                      <span className="block font-label text-xs text-background-200/70">{item.role}</span>
                    </span>
                  </figcaption>
                </figure>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}